import React from "react";
import "./selectCategory.css";
import MatchScheduleList from "../matchsceduleList";
import { useAudio } from "../../../../Providers/AudioProvider";
import useUserInfo from "../../../../Hooks/useUserInfo";
import Iplwar from "../ipllanding";
import ChooseIplTeam from "../chooseteam";
import { GetIplBoosterList, IplMatchData } from "../../../../apis/iplBattle";
import Tv from "../../Tv";

function LeagueSelection() {
  const { userDetails, updateUserInfo ,watchScreen,updatewatchScreenInfo} = useUserInfo();
  const playClick = useAudio();

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Tv,
      currentComponentText: "TVPage",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };
  const fetchMatchList = async (category) => {
    console.log(category,'category');
    
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const result = await IplMatchData(category);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (result) {
      // setMatchList(result);
      return result; // :white_check_mark: Return result to be used in handleGoToIpl
    } else {
      return null;
    }
  };
  const fetchBoosterList = async () => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const result = await GetIplBoosterList(
      userDetails?.userDetails?.telegramId
    );
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (result) {
      // setMatchList(result);
      return result; // :white_check_mark: Return result to be used in handleGoToIpl
    } else {
      console.log("Error in MatchScheduleList API");
      return null;
    }
  };
  const handleGoToIpl = async (category) => {
    updatewatchScreenInfo((prev) => ({
        ...prev,
        cricketLeague :category,
      }));
    const response = await fetchMatchList(category); // :white_check_mark: Wait for updated data
    const BoosterData = await fetchBoosterList(category);
    if (!response) return; // Handle API error case
    
     if (response) {
      updatewatchScreenInfo((prev) => ({
        ...prev,
        currentBattleDetails: response?.currentBattleDetails,
        chosenTeam: response?.chosenTeam,
        current_battle: response?.current_battle,
      }));
    }
    if (BoosterData){
      updatewatchScreenInfo((prev) => ({
        ...prev,
        ipl_booster_list :BoosterData?.boosters,
      }));
      updateUserInfo((prev) => ({
        ...prev,
        ipl_booster_list_static:BoosterData?.boosters,
      }));
     
    }
    if (response.playStarted) {
      goToThePage(Iplwar, "Iplwar");
    } else if (!response.chosenTeam?.[0]?.status) {
      goToThePage(ChooseIplTeam, "ChooseIplTeam");
    } else if (response?.current_battle?.length == 0) {
      goToThePage(MatchScheduleList, "MatchScheduleList");
    } else if (!response.playStarted) {
      goToThePage(MatchScheduleList, "MatchScheduleList");
    } else if (response.playStarted) {
      goToThePage(Iplwar, "Iplwar");
    }
  };

  return (
    <div className="league-selection-container">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints league-selection-cancel-btn"
      />
      <div className="league-selection-content" style={{pointerEvents:'fill'}}>
        <div className="league-selection-header">
          <img 
            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/leagueheader.jpg" 
            alt="League Header"
            className="league-selection-header-img"
          />
        </div>

        <div className="league-selection-divider">
          <div className="league-selection-divider-line"></div>
          <h4 className="league-selection-divider-text">CURRENT LEAGUE</h4>
        </div>
        <div className="league-selection-leagues-row">
          {/* Tamil Nadu T20 */}
          <div className="league-selection-league-card-tn" onClick={()=>handleGoToIpl("tnpl")}>           
              <div className="league-selection-league-icons">
                <img 
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/tnpl.png" 
                  alt="TNPL Logo" 
                  className="league-selection-tnpl-logo"
                />
              </div>
            
          </div>

          {/* Maharashtra T20 */}
          <div className="league-selection-league-card-mh" onClick={()=>handleGoToIpl("mpl")}>
              <div className="league-selection-league-icons">
                <img 
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/mpl.png" 
                  alt="MPL Logo" 
                  className="league-selection-mpl-logo"
                />
              </div>            
          </div>
        </div>

        <div className="league-selection-divider">
          <div className="league-selection-divider-line"></div>
          <h4 className="league-selection-divider-text">PAST LEAGUE</h4>
        </div>

        <div className="league-selection-leagues-row">
          {/* India T20 */}
          <div className="league-selection-league-card-india">
            <div className="league-selection-league-icons" onClick={()=>handleGoToIpl("ipl")}>
                {/* <button className="ufw-ipl-btn">btn</button> */}
              <img 
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/ufw-ipl.jpg" 
                alt="UFW IPL" 
                className="ufw-ipl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeagueSelection; 